import * as React from "react";
import Either from "eitherx";
import Panel from "../core/Panel";
import PageContainer from "../core/PageContainer";
import styled from "styled-components";
import * as Sentry from "@sentry/browser";

const shouldDisplayError = process.env.NODE_ENV !== "production";

const ErrorPanel = styled(Panel)`
  margin-top: 10px;
`;

function ErrorComponent({ error, info }) {
  return (
    <ErrorPanel type={"danger"} heading={"Page Render Error"}>
      <p>
        An error has occurred! Our engineering team has been notified, but in
        the meantime please refresh the page to try again.
      </p>
      {shouldDisplayError && (
        <>
          <p>Error:</p>
          <pre>{error.toString()}</pre>
          <p>Component Stack Trace:</p>
          <pre>{info ? info.componentStack : "undefined"}</pre>
        </>
      )}
    </ErrorPanel>
  );
}

export default function ErrorHandler({
  render,
  renderInPage = false,
}: {
  render: React.ReactNode;
  renderInPage: boolean;
}) {
  return (
    <Either
      render={render}
      catchError={({ error, info }) =>
        renderInPage ? (
          <PageContainer>
            <p>&nbsp;</p>
            <ErrorComponent {...{ error, info }} />
          </PageContainer>
        ) : (
          <>
            <p>&nbsp;</p>
            <ErrorComponent {...{ error, info }} />
          </>
        )
      }
      handleError={({ error, info }: { error: Error; info: object }) => {
        Sentry.withScope(scope => {
          scope.setExtra("react_error_info", info);
          Sentry.captureException(error);
        });
      }}
    />
  );
}

export function wrapComponentForErrors(Component: any, { isPage = true } = {}) {
  return function ErrorWrappingComponent({ ...props }) {
    return (
      <ErrorHandler
        render={() => <Component {...props} />}
        renderInPage={isPage}
      />
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/components/utility/ErrorHandler.tsx